import { firestore } from "../firebase.js";

const state = {
  todasLasCategorias: [],
};
const mutations = {
  obtenerCategorias(state, categorias) {
    state.todasLasCategorias = categorias;
  },
};

const actions = {
  /* funcion para obtener las categorias desde firestore */
  async obtenerCategorias({ commit }) {
    const categorias = [];
    const categoriasDB = await firestore.collection("categorias").get();
    categoriasDB.docs.forEach((doc) => {
      const category = doc.data();
      category.id = doc.id;
      categorias.push(category);
    });
    commit("obtenerCategorias", categorias);
  },
  limpiarStore({ commit }) {
    commit("obtenerCategorias", []);
  },
};
const getters = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
